// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Ensure.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/* https://github.com/zertosh/invariant/blob/master/invariant.js */
/**
* Ensure the condition is met. Otherwise, raise an Error with formatted message
*
* Provide sprintf-style format message (only %s is supported) and arguments
* to provide information about what broke and what you were
* expecting.
*
* @param {boolean} condition
* @param {string} msg - Format message
* @param {Array<any>} args - Format arguments
*/
export default function ensure(condition: boolean, msg: string, ...args : Array<any>) {
  if (!condition) {
    let argIndex = 0;
    const error = new Error(
      msg.replace(/%s/g, () => args[argIndex++])
    );

    error.name = 'Pre-check Failed';

    throw error;
  }
}



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.Ensure.js